import { Card, Tooltip, Typography } from "@mui/material";
import type { LegacyMetricsStat } from "../legacyMetrics.types";

/**
 * One "Top Level Stats" tile (Figma "KPI" component): outlined, left-aligned,
 * small label on one line, value, optional caption. The tooltip shows a label
 * the tile width cuts off; the group's accessible name carries it in full.
 */
export function StatTile({ label, value, caption }: Omit<LegacyMetricsStat, "key">) {
  return (
    <Card
      variant="outlined"
      role="group"
      aria-label={label}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.5,
        p: 2,
        height: "100%",
        borderRadius: 2,
      }}
    >
      <Tooltip title={label}>
        <Typography
          component="div"
          noWrap
          color="text.secondary"
          sx={{ fontSize: 11, fontWeight: 600, lineHeight: "16px", letterSpacing: "0.08em" }}
        >
          {label}
        </Typography>
      </Tooltip>
      <Typography
        component="div"
        color="text.primary"
        sx={{ fontSize: 20, fontWeight: 600, lineHeight: "28px" }}
      >
        {value}
      </Typography>
      {caption && (
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: "21px" }}>
          {caption}
        </Typography>
      )}
    </Card>
  );
}
